module.exports = __webpack_public_path__ + "img/message-minus.14f28821.svg";